import { Component, Prop, Vue } from 'nuxt-property-decorator';

export type BreadcrumbsItem = { text: string; to?: string };

@Component
export default class Breadcrumbs extends Vue {
  @Prop()
  items!: BreadcrumbsItem[];
}
